import Marquee from "react-fast-marquee";

const PHRASES = ["DARK & MOODY", "LATEST RELEASE", "BEJNNI", "OUT NOW"];

export default function EditorialMarquee() {
    return (
        <div
            data-testid="editorial-marquee"
            className="border-y border-white/10 py-8 md:py-12"
        >
            <Marquee speed={25} gradient={false} pauseOnHover>
                {PHRASES.map((p) => (
                    <span
                        key={p}
                        className="outline-type mx-10 font-serif text-6xl italic leading-none md:mx-16 md:text-8xl"
                    >
                        {p}
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
